<template lang="pug">
    .component-tabs
        ul.tabs(:id="'tabs-'+_uid", data-tabs='')
            li.tabs-title(v-for="(tab,index) in tabs")
                router-link(:to="{name:tab.name, params:{id:$route.params.id}}", :aria-selected="tab.pathName === $route.meta.name") {{tab.headerName}}
        .tabs-content(:data-tabs-content='$route.meta.name')
            slot
</template>
<script type="text/babel">
    export default{
        name: "RouterTabHeaders",
        components: {},
        data(){
            return {}
        },
        created(){
        },
        mounted(){

        },
        methods: {},
        props: {
            tabs: Array
        }
    }
</script>
<style lang="sass" rel="stylesheet/sass">
  .tabs-content
    border: none
</style>


// WEBPACK FOOTER //
// RouterTabHeaders.vue?5c2d4cc4